import React from 'react';
import { Check } from 'lucide-react';
import { features } from '../data/mock';

const WhyChooseUs = () => {
  return (
    <section className="bg-slate-900 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Why Choose WrapAlot Specialty Filmz for Car Wrap Installation in Sacramento?
            </h2>
            <p className="text-gray-400 text-lg leading-relaxed">
              Located at 1817 Del Paso Blvd in the heart of Sacramento, CA, we specialize in transforming vehicles with high-quality wraps, custom graphics and paint protection films. Our team of certified installers brings years of experience and a commitment to excellence in every project — serving Sacramento, Elk Grove, Roseville, Folsom and the greater Sacramento County area.
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {features.map((feature, index) => (
              <div 
                key={index}
                className="flex items-center gap-3 p-4 bg-slate-800/50 rounded-lg hover:bg-slate-800/70 transition-colors"
              >
                <div className="w-6 h-6 bg-cyan-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <Check className="w-4 h-4 text-cyan-400" />
                </div>
                <span className="text-white font-medium">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
